'use strict';

const BN = require('bn.js');

const obfuscator = [0x7a616d41, 0x632e6e6f, 0x42206d6f, 0x736b6f6f];
const delta = 0x9e3779b9;
const minLargeIdValue = Math.pow(2, 43);
const minLargeIdLength = 15;
const maxUInt64 = new BN('ffffffffffffffff', 16);
const maskBits16 = new BN(0x10000);
const maskBits20 = new BN(0x100000);
const maskBits32 = new BN(0x100000000);
const xorBits = new BN(0xc2f93);

function simpleEncode(v, k) {
  let [y, z] = v;
  let sum = 0;

  for (let i = 0; i < 32; i++) {
    sum += delta;
    y += ((z << 4) + k[0]) ^ (z + sum) ^ ((z >>> 5) + k[1]);
    y >>>= 0;
    z += ((y << 4) + k[2]) ^ (y + sum) ^ ((y >>> 5) + k[3]);
    z >>>= 0;
  }

  return [y, z];
}

function simpleDecode(v, k) {
  let [y, z] = v;
  let sum = delta << 5;

  for (let i = 0; i < 32; i++) {
    z -= ((y << 4) + k[2]) ^ (y + sum) ^ ((y >>> 5) + k[3]);
    z >>>= 0;
    y -= ((z << 4) + k[0]) ^ (z + sum) ^ ((z >>> 5) + k[1]);
    y >>>= 0;
    sum -= delta;
  }

  return [y, z];
}

function disguise(v) {
  const [y, z] = simpleEncode(
    [Number(v.mod(maskBits32)), Number(v.div(maskBits32))],
    obfuscator
  );

  return new BN(y).add(new BN(z).mul(maskBits32)).toString(36);
}

function reveal(v) {
  const [y, z] = simpleDecode(
    [Number(v.mod(maskBits32)), Number(v.div(maskBits32))],
    obfuscator
  );

  return new BN(y).add(new BN(z).mul(maskBits32));
}

function computeChecksum(id) {
  let _id = id;
  let checksum = _id.mod(maskBits20);

  for (let i = 0; i < 3; i++) {
    _id = _id.div(maskBits16);
    checksum = checksum.add(_id.mod(maskBits20));
  }

  return checksum.xor(xorBits).and(maskBits20.subn(1));
}

exports.encryptCustomerId = (id) => {
  const _id = new BN(id);

  if (_id.ltn(1) || _id.gt(maxUInt64)) return null;

  const checksum = computeChecksum(_id);
  const encryptedId =
    _id < minLargeIdValue
      ? disguise(_id.shln(20).add(checksum))
      : String(checksum).padStart(7, 0) + disguise(_id);

  return 'A' + encryptedId.toUpperCase();
};

exports.decryptCustomerId = (id) => {
  if (id == null) return 0;

  const _id = reveal(
    new BN(id.slice(id.length < minLargeIdLength ? 1 : 8), 36)
  );
  let checksum;
  let decryptedId;

  if (id.length < minLargeIdLength) {
    checksum = _id.and(maskBits20.subn(1));
    decryptedId = _id.shrn(20);
  } else {
    checksum = new BN(id.slice(1, 8));
    decryptedId = _id;
  }

  if (computeChecksum(decryptedId).cmp(checksum) !== 0) return 0;

  return String(decryptedId);
};
